import React from "react";
import { Flex, Loader } from "@fluentui/react-northstar";

const FullScreenLoader = ({ label }: { label: string }) => {
  return (
    <Flex className="h-screen" hAlign="center" vAlign="center">
      <Loader label={label} />
    </Flex>
  );
};

export default FullScreenLoader;
